import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltRecorderPlayerSubtitlesWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-subtitles-wireframe", __assign({}, transformedProps), children));
};
export default VeltRecorderPlayerSubtitlesWireframe;
